import {
  RastreioCancerInput,
  RastreioCancerPerguntaDbEnum,
  RastreioCancerPerguntaOpcaoEnum,
} from 'graphql/types.generated'

import { AnoSelectModel } from '../citopatologico/AnoSelectField'
import {
  anamneseCirurgiaTableOptions,
  MamografiaPerguntaField,
  RequisicaoExameMamografiaFormValues,
} from './model-mamografia'

const cirurgiaAnoFields = anamneseCirurgiaTableOptions.flatMap(({ valueDireita, valueEsquerda }) => [
  valueDireita,
  valueEsquerda,
])

const MAMOGRAFIA_PERGUNTAS_DATA = new Set<RastreioCancerPerguntaDbEnum>([MamografiaPerguntaField.dataSolicitacao])

const MAMOGRAFIA_PERGUNTAS_TEXTO = new Set<RastreioCancerPerguntaDbEnum>([
  MamografiaPerguntaField.anoUltimaMamografia,
  MamografiaPerguntaField.anoRadioterapiaMamaDireita,
  MamografiaPerguntaField.anoRadioterapiaMamaEsquerda,
  MamografiaPerguntaField.nomeResponsavel,
  MamografiaPerguntaField.cns,
  MamografiaPerguntaField.numeroConselho,
  MamografiaPerguntaField.siglaNomeConselho,
  ...cirurgiaAnoFields,
])

const isEmpty = (value: unknown): boolean =>
  value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0)

const extractDescricao = (value: unknown): string =>
  typeof value === 'object' ? (value as AnoSelectModel).nome : String(value)

export const convertMamografiaFormToRastreioCancer = (
  values: RequisicaoExameMamografiaFormValues
): RastreioCancerInput[] => {
  // openedAccordions é estado de UI (acordeões abertos), não uma pergunta — não deve ser enviado.
  const { openedAccordions, ...perguntaValues } = values
  return Object.entries(perguntaValues)
    .filter(([, value]) => !isEmpty(value))
    .map(
      ([perguntaKey, value]): RastreioCancerInput => {
        const pergunta = perguntaKey as RastreioCancerPerguntaDbEnum

        if (MAMOGRAFIA_PERGUNTAS_DATA.has(pergunta)) {
          return { pergunta, data: (value as unknown) as LocalDate }
        }

        if (MAMOGRAFIA_PERGUNTAS_TEXTO.has(pergunta)) {
          return { pergunta, descricao: extractDescricao(value) }
        }

        if (pergunta === MamografiaPerguntaField.fezCirurgiaMama) {
          return {
            pergunta,
            opcoes: [value ? RastreioCancerPerguntaOpcaoEnum.SIM : RastreioCancerPerguntaOpcaoEnum.NAO],
          }
        }

        return {
          pergunta,
          opcoes: Array.isArray(value)
            ? (value as RastreioCancerPerguntaOpcaoEnum[])
            : [value as RastreioCancerPerguntaOpcaoEnum],
        }
      }
    )
}
